import { render, staticRenderFns } from "./AutoLogout.vue?vue&type=template&id=4aea5f0d"
import script from "./AutoLogout.vue?vue&type=script&lang=ts"
export * from "./AutoLogout.vue?vue&type=script&lang=ts"
import style0 from "./AutoLogout.vue?vue&type=style&index=0&id=4aea5f0d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports